var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25326 3.66654C6.2529 4.37378 5.97161 5.05192 5.47126 5.55176C4.97092 6.05161 4.2925 6.33222 3.58526 6.33187C2.87801 6.33152 2.19987 6.05022 1.70003 5.54988C1.20018 5.04953 0.919569 4.37111 0.919922 3.66387C0.920276 2.95662 1.20157 2.27849 1.70191 1.77864C2.20226 1.27879 2.88068 0.998182 3.58792 0.998535C4.29517 0.998889 4.9733 1.28018 5.47315 1.78053C5.973 2.28087 6.25361 2.95929 6.25326 3.66654V3.66654ZM6.33326 8.30654H0.999922V24.9999H6.33326V8.30654ZM14.7599 8.30654H9.45326V24.9999H14.7066V16.2399C14.7066 11.3599 21.0666 10.9065 21.0666 16.2399V24.9999H26.3333V14.4265C26.3333 6.19987 16.9199 6.50654 14.7066 10.5465L14.7599 8.30654V8.30654Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c90b23e3d1b44254e47c471d5c160e47.svg";
export { ForwardRef as ReactComponent };